import { render } from "./SellerSignup.vue?vue&type=template&id=4de7df22&scoped=true"
import script from "./SellerSignup.vue?vue&type=script&lang=js"
export * from "./SellerSignup.vue?vue&type=script&lang=js"

import "./SellerSignup.vue?vue&type=style&index=0&id=4de7df22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de7df22"]])

export default __exports__